// FruitsZakatTable.js
import React, { useState } from 'react';
function FruitsZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Status</th>
          <th > Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Nisab zakat buah-buahan dan tanaman</td>
          <td>{result.threshold} (kg)</td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari buah-buahan)</td>
          <td>{result.fruitsZakatAmount} (kg) </td>
        </tr>
        <tr >
          <td>Jumlah zakat yang wajib dikeluarkan (dari uang)</td>
          <td>{result.moneyZakatAmount}</td>
        </tr>
      </tbody>
    </table>
  );
}
export default FruitsZakatTable;